<template>
  <div v-if="parentData">
    <PercentTable :data="parentData" />
    <PercentTable
      v-for="(childItem, index) in childItems"
      :key="`d-${index}`"
      :data="childItem"
    />
  </div>
</template>

<script>
import PercentTable from "../percent-table/PercentTable.vue";
import { computed, toRefs } from "vue";
import { pathOr } from "ramda";
export default {
  components: { PercentTable },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // generate props data
    const { data } = toRefs(props);

    const generateItems = (items) => {
      return items.map((item) => {
        return {
          title: pathOr("", ["title"], item),
          rankPercent: pathOr(0, ["rank_percent"], item),
          percentItems: new Array(pathOr(0, ["rank_percent"], item) / 10),
          rankValue: pathOr(0, ["rank_value"], item),
          value: pathOr(0, ["value"], item),
          componentNumber: pathOr("", ["component_number"], item),
        };
      });
    };

    const parentData = computed(() => {
      const items = pathOr([], ["parent", "items"], data.value);
      if (items.length <= 0) return null;
      return {
        title: pathOr("", ["parent", "title"], data.value),
        items: generateItems(items),
      };
    });
    const childItems = computed(() => {
      const children = pathOr([], ["children"], data.value);
      return children.map((child) => {
        const items = pathOr([], ["items"], child);
        return {
          title: pathOr("", ["title"], child),
          items: generateItems(items),
        };
      });
    });

    // return data to be used in template
    return { parentData, childItems };
  },
};
</script>
